<app-header *ngIf="!hideHeaderFooter"></app-header>
<router-outlet></router-outlet>
<app-footer *ngIf="!hideHeaderFooter"></app-footer>

<ngx-spinner 
  name="globalSpinner" 
  bdColor="rgba(0, 0, 0, 0.5)" 
  size="small" 
  color="#fff" 
  [fullScreen]="true" 
  type="ball-scale-multiple"
  template="<img src='/assets/Spinner/Mascot_for_spinner.svg' alt='' class='animate__animated animate__fadeIn animate__infinite pb-small-0 pb-lg-3' style='height: 100px; width:50px;'>">
  
  <p style="color: white;" class="font-weight-bold">
    Loading<span class="dot-anim ml-1">.</span><span class="dot-anim">.</span><span class="dot-anim">.</span>
  </p>
</ngx-spinner>
